




































































































































































































































































































































































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import LoadingIndicator from '@components/LoadingIndicator'
import AddPurchaseOrderLineItemTriggerModal from '@triggers/PurchaseOrder/AddPurchaseOrderLineItemTriggerModal'
import RemovePurchaseOrderLineItemTriggerModal from '@triggers/PurchaseOrder/RemovePurchaseOrderLineItemTriggerModal'
import RemovePurchaseOrderDiscountLineItemTriggerModal from '@triggers/PurchaseOrder/RemovePurchaseOrderDiscountLineItemTriggerModal'
import AddPurchaseDiscountTriggerModal from '@triggers/CheckoutWizard/AddPurchaseDiscountTriggerModal'
import UpdateLineItemDiscountTriggerModal from '@triggers/CheckoutWizard/UpdateLineItemDiscountTriggerModal'
import BulkEditOffersTriggerModal from '@triggers/Offers/BulkEditOffersTriggerModal'
import ExtendOffersExpirationTriggerModal from '@triggers/Offers/ExtendOffersExpirationTriggerModal'
import Timeline from '@modules/ui/components/Timeline'
import SetHubspotDealTriggerModal from '@triggers/Campaign/SetHubspotDealTriggerModal'
import SetRealizedGoalPriceTriggerModal from '@triggers/Campaign/SetRealizedGoalPriceTriggerModal'
import RecapResourceList from '@superComponents/Recap/RecapResourceList'
import PayoutBoardOfferResourceList from '@superUI/ResourceList/PayoutBoardOfferResourceList'
import ShippingAreaResourceList from '@superUI/ResourceList/ShippingAreaResourceList'

settings =
  name: 'PurchaseOrderShow'

  resources:
    item:
      resourceName: 'purchase_order'
      slug: 'purchase_orders/:purchaseOrderId'
    line_items:
      resourceName: 'purchase_order_line_item'
      slug: 'purchase_orders/:purchaseOrderId/purchase_order_line_items'
      params:
        limit: 9999
    summary:
      resourceName: 'summary'
      slug: 'purchase_orders/:purchaseOrderId/summary'
      fetch: false
    invoice:
      resourceName: 'invoice'
      slug: 'purchase_orders/:purchaseOrderId/invoice'
      fetch: false
    remittance:
      resourceName: 'remittance'
      slug: 'purchase_orders/:purchaseOrderId/remittance'
      fetch: false
    recaps:
      resourceName: 'recaps'
      slug: 'purchase_orders/:purchaseOrderId/recaps'
      infinityScroll: true
    payout_board_offers:
      resourceName: 'offers'
      slug: 'purchase_orders/:purchaseOrderId/offers'
      infinityScroll: true
    shipping_areas:
      resourceName: 'shipping_area'
      slug: 'purchase_orders/:purchaseOrderId/shipping_areas'
      infinityScroll: true
    offers:
      resourceName: 'offers'
      slug: 'offers'
      fetch: false

  vue:
    props: ['purchaseOrderId']
    components: {
      SuperContainerView,
      Back,
      LoadingIndicator,
      AddPurchaseOrderLineItemTriggerModal,
      RemovePurchaseOrderLineItemTriggerModal,
      RemovePurchaseOrderDiscountLineItemTriggerModal,
      AddPurchaseDiscountTriggerModal,
      UpdateLineItemDiscountTriggerModal,
      RemovePurchaseOrderDiscountLineItemTriggerModal,
      BulkEditOffersTriggerModal,
      ExtendOffersExpirationTriggerModal,
      Timeline,
      SetHubspotDealTriggerModal,
      SetRealizedGoalPriceTriggerModal,
      RecapResourceList,
      PayoutBoardOfferResourceList,
      ShippingAreaResourceList,
    }

    data: ->
      selectedLineItemIds: []

    computed:
      routeIsPurchaseOrderShow: -> @$route.name is 'PurchaseOrderShowPage'

      deniedPlusIgnoredCount: -> @ctxStats(@item).offer.denied_count + @ctxStats(@item).offer.ignored_count

      isLocked: ->
        @line_items.some((li) => li.locked)

      selectedLineItems: ->
        @line_items.filter((li) => @selectedLineItemIds.includes(li.id))

      selectedOffers: ->
        @selectedLineItems.map((li) => @ctxOffer(li))

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity state, resourceKey, data, options

      onLoadItemCompleted: (resourceKey) ->
        switch resourceKey
          when 'item'
            @fetch 'summary'

      hiLineItem: (lineItem) ->
        return unless lineItem.available_dates?.length
        route =
          name: 'PurchaseOrderLineItemEditPage'
          params:
            purchaseOrderId: @item.id
            purchaseOrderItemId: lineItem.id
        @$router.push route

      hiEditRecap: (recapId) ->
        @$router.push { name: 'PurchaseOrderRecapEditPage', params: { recapId } }

      audienceListingForLineItem: (lineItem) ->
        listing = @ctxAudienceListing lineItem
        listing if listing.id
      vendorListingForLineItem: (lineItem) ->
        listing = @ctxVendorListing lineItem
        listing if listing.id
      listingForLineItem: (lineItem) ->
        listing = null
        listing ||= @audienceListingForLineItem lineItem
        listing ||= @vendorListingForLineItem lineItem
        listing

      hasListingForLineItem: (lineItem) -> !!@listingForLineItem(lineItem)
      hasOfferForLineItem: (lineItem) -> @ctxOffer(lineItem)?.id?
      generatingOfferForLineItem: (lineItem) -> @hasListingForLineItem(lineItem) && not @hasOfferForLineItem(lineItem)

      addLineItemTrigger: (lineItem, offer) ->
        audienceListing = @audienceListingForLineItem(lineItem)
        vendorListing = @vendorListingForLineItem(lineItem)
        payloadOptions =
          purchase_order_id: @item.id
          audience_listing_id: audienceListing?.id
          vendor_listing_id: vendorListing?.id
          offer_id: offer.id
        modalOptions =
          title: @formatTitleForLineItem(lineItem)

        @$refs.addLineItemTrigger.fire(payloadOptions, modalOptions)
      onLineItemsAddLineItem: ->
        @refetchPO()
        @$refs.addLineItemTrigger.close()

      removeLineItemTrigger: (lineItem) ->
        payloadOptions =
          purchase_order_id: @item.id
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.removeLineItemTrigger.fire(payloadOptions, modalOptions)
      onLineItemsRemoveLineItem: ->
        @refetchPO()
        @$refs.removeLineItemTrigger.close()

      removePurchaseDiscountLineItemTrigger: (lineItem) ->
        payloadOptions =
          purchase_order_id: @item.id
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.removeLineItemDiscountTrigger.fire(payloadOptions, modalOptions)
      onItemRemoveLineItem: ->
        @refetchPO()
        @$refs.removeLineItemDiscountTrigger.close()

      updateLineItemDiscountTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateLineItemDiscountTrigger.fire(payloadOptions, modalOptions)
      onLineItemsUpdateLineItemDiscount: ->
        @refetchPO()
        @$refs.updateLineItemDiscountTrigger.close()

      addPurchaseDiscountTrigger: ->
        @$refs.addPurchaseDiscountTrigger.fire()
      onItemAddPurchaseDiscount: ->
        @refetchPO()
        @$refs.addPurchaseDiscountTrigger.close()

      hiDownloadInvoiceCSV: ->
        @triggerResource 'invoice', 'download_invoice', { invoice_id: @ctxInvoice(@item).id }
      hiDownloadRemittanceCSV: ->
        @triggerResource 'remittance', 'download_remittance', { remittance_id: @ctxRemittance(@item).id }

      hiRegeratePayments: ->
        @triggerResource 'item', 'regenerate_payments', { invoice_id: @ctxInvoice(@item).id }
        @showFlash({ info: 'Invoice and remittance queued up, will take a minute to generate' })

      hiResetResolvedAt: (d) ->
        @triggerResource 'item', 'reset_resolved_at', { resolved_at: d }

      hiPromptToExtendOffersExpiration: ->
        payloadOptions = {}
        modalOptions = {}
        @$refs.extendOffersExpirationTrigger.fire(payloadOptions, modalOptions)
      onItemExtendOffersExpiration: ->
        @$refs.extendOffersExpirationTrigger.close()
        @$refs.offerResourceList.clearSelection()

      hiPromptToBulkEditOffers: ->
        modalConfig =
          offerIds: @pluck(@selectedOffers, 'id')
        @$refs.bulkEditOffersTrigger.fire {}, modalConfig
      onOffersBulkEdit: ->
        @$refs.bulkEditOffersTrigger.close()

      refetchPO: ->
        fn = => @fetch 'item'
        fn() # fetch now
        setTimeout fn, 10000 # fetch again in case payments are still being generated

      formatTitleForLineItem: (lineItem) ->
        listing = @listingForLineItem lineItem
        # @$options.filters.formatListingTitle { ...listing, calendar_dates: lineItem.available_dates || [] }
        listing.formatted_title || listing.title

      formatStartDateForLineItem: (lineItem) ->
        @$options.filters.formatDate lineItem.available_dates[0]?.starts_on

      hiSetHubspotDealTrigger: () ->
        payloadOptions = { purchase_order_id: @item.id }
        modalOptions = { deal_id: @item.deal_ids[0], basis: @item.basis }
        @$refs.setHubspotDealTrigger.fire payloadOptions, modalOptions
      onItemSetHubspotDeal: ->
        @$refs.setHubspotDealTrigger.close()

      hiCopyDealIdToClipboard: (event) ->
        @copyToClipboard event, @item.deal_ids.join(', ')
        @showFlash { 'Message:': 'Copied to clipboard' }

      hiSetRealizedGoalPriceTrigger: () ->
        payloadOptions = { purchase_order_id: @item.id }
        modalOptions = { goal_for_realized_final_price: @item.goal_for_realized_final_price }
        @$refs.setRealizedGoalPriceTrigger.fire payloadOptions, modalOptions
      onItemSetRealizedGoalPrice: ->
        @$refs.setRealizedGoalPriceTrigger.close()

      hiLineItemSelectAll: ->
        @selectedLineItemIds = @pluck(@line_items, 'id')

      hiLineItemUnselectAll: ->
        @selectedLineItemIds = []

      hiLineItemSelectCustom: (offerStatus) ->
        filteredLineItems = @line_items.filter((li) => @ctxState(li).current_offer_status is offerStatus)
        @selectedLineItemIds = @pluck(filteredLineItems, 'id')

      exportShippingAreas: ->
        @triggerResource 'item', 'export_shipping_areas'

    watch:
      routeIsPurchaseOrderShow: (value) ->
        if value
          @clearDataForResourceKey 'summary'
          @fetch 'item'

export default VueOptions.vue settings
